import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FlyingRobots from '../components/FlyingRobots';
import { blogPosts } from '../mock';
import useScrollReveal from '../hooks/useScrollReveal';

export default function Blog() {
  useScrollReveal([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#050506] text-white relative min-h-screen">
      <FlyingRobots />
      <Navbar />

      <section className="relative pt-[140px] pb-16 border-b border-white/5 overflow-hidden">
        <div className="halftone" />
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              'radial-gradient(600px circle at 30% 30%, rgba(16,185,129,0.14), transparent 60%)',
          }}
        />
        <div className="relative mx-auto max-w-[1400px] px-6">
          <p className="eyebrow mb-3">Blog</p>
          <h1 className="h-display text-[46px] md:text-[64px] leading-[1.02] max-w-[900px]">
            Insights on <span className="text-[#10b981]">grocery intelligence</span>.
          </h1>
          <p className="text-white/60 text-[16px] md:text-[18px] max-w-[600px] mt-6">
            Thoughts on AI, supply chain, and the intelligence that runs modern retail.
          </p>
        </div>
      </section>

      <section className="relative py-20 overflow-hidden">
        <div className="mx-auto max-w-[1400px] px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {blogPosts.map((post) => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                className="group p-6 rounded-lg border border-white/10 bg-white/[0.02] hover:bg-white/[0.05] hover:border-white/20 transition-all duration-300"
              >
                <p className="eyebrow text-white/50 mb-2 text-[12px]">{post.date}</p>
                <h2 className="h-sans text-[20px] md:text-[24px] font-medium mb-3 group-hover:text-[#10b981] transition-colors">
                  {post.title}
                </h2>
                <p className="text-white/60 text-[14px] md:text-[16px] mb-4 line-clamp-2">
                  {post.excerpt}
                </p>
                <div className="flex flex-wrap gap-2">
                  {post.tags.map((tag) => (
                    <span
                      key={tag}
                      className="inline-block px-2 py-1 rounded text-[11px] text-white/50 border border-white/10"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
